module.exports = __webpack_public_path__ + "static/img/sq-dj.7314c242.png";